/**
 * @generated SignedSource<<00097a66e373260d49c4d3b2eab1ff30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerPropertyLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewerUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomerPropertyNavigation_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomerPropertyNavigation_properties"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

node.hash = "d511140ac6d627bb8dbc83f560551d2c";

module.exports = node;
